/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OnboardingStep {
    TERMS = 'TERMS',
    FORM = 'FORM',
    PHOTO_UPLOAD = 'PHOTO_UPLOAD',
    FACE_VERIFICATION = 'FACE_VERIFICATION',
    APPLIED = 'APPLIED',
    WAITLISTED = 'WAITLISTED',
    DENIED = 'DENIED',
    COMPLETED = 'COMPLETED',
}
